import { type ContractorBadgeVerificationListData } from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";

/**
 * Checks if a badge verification has been completed (either uploaded or skipped).
 *
 * @param verification - The verification record, or undefined if none exists
 * @returns true if verification is complete, false if pending or no record exists
 */
export function isVerificationComplete(
  verification: ContractorBadgeVerificationListData | undefined
): boolean {
  if (!isDefined(verification)) {
    return false;
  }

  return (
    isDefined(verification.attributes.uploadedAt) || isDefined(verification.attributes.skippedAt)
  );
}
